import { FC } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { wacToken } from "@/libraries/design/foundations";
import { experiments, ExperimentView } from "@/utils/experiment";

export interface Jfind1249SubHeadingProps {
    returnString?: boolean;
}

export const Jfind1249SubHeading: FC<Jfind1249SubHeadingProps> = ({
    returnString
}) => {
    const intl = useIntl();

    const jfind1249SubHeaderText = intl.formatMessage({
        id: "BxpSignup.accountCreation.subHeading.startForFree",
        defaultMessage: "Start for free. No credit card needed."
    });

    const controlSubHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderText",
        defaultMessage: "It’s free for up to 10 users - no credit card needed."
    });

    return (
        <ExperimentView
            experiment={
                experiments.jfind1249RemoveExpectationOfFreeOnTryCloudSignUp
            }
            render={(value) => {
                switch (value) {
                    case "variant":
                        return returnString ? (
                            jfind1249SubHeaderText
                        ) : (
                            <p css={subHeaderCss}>{jfind1249SubHeaderText}</p>
                        );
                    default:
                        return returnString ? (
                            controlSubHeaderText
                        ) : (
                            <p css={subHeaderCss}>{controlSubHeaderText}</p>
                        );
                }
            }}
        />
    );
};
const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "0 0 24px",
    textAlign: "center"
});
